import { useQueryClient } from "@tanstack/react-query";

import { showToast } from "@/components/ui";
import { useDeleteMappingSessionMutation } from "@/graphql/generated";

export function useDeleteMappingReviewSession() {
  const queryClient = useQueryClient();
  const mutation = useDeleteMappingSessionMutation({
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["MarketplaceMappingSessions"],
      });
      showToast.success("Mapping deleted", "The mapping session was removed.");
    },
    onError: (err) => {
      showToast.error(
        "Delete failed",
        err instanceof Error ? err.message : "Could not delete the session.",
      );
    },
  });

  const deleteSession = (sessionId: string, removeSavedAnswers: boolean) => {
    if (mutation.isPending) return;
    mutation.mutate({ input: { sessionId, removeSavedAnswers } });
  };

  return { deleteSession, isDeleting: mutation.isPending };
}
